import {Filter} from '../../../core/filter/filter';

export class EmployeeFilter extends Filter {
  archived?: boolean;
  text?: string;
}
